<template>
	<div class="card-body shadow p-3 bg-dark rounded">
		<h1>관리자에게 권한 요청</h1>
		<p class="text-muted"></p>
		<!-- <div class="input-group mb-3">
			<div class="input-group-prepend">
				<span class="input-group-text">
					<i class="icon-key"></i>
				</span>
			</div>
			 <input class="form-control" type="text" placeholder="사번" v-model="sabun">
		</div> -->
		<div class="input-group mb-3">
			<div class="input-group-prepend">
				<span class="input-group-text">
					<i class="icon-user"></i>
				</span>
			</div>
			 <input class="form-control" type="text" placeholder="ID" v-model="userId" @keyup.enter="requestPermission">
		</div>
		<div class="input-group mb-3">
			<div class="input-group-prepend">
				<span class="input-group-text">
					<i class="icon-lock"></i>
				</span>
			</div>
			 비밀번호는 사번과 동일하게 생성됩니다.
		</div>
		 <div class="input-group mb-4">
			<div class="col-4 text-label">
			    요청 권한 선택
			</div>

			<div v-for="permission in permissions" class="col-md-2 text-right">
			    <button class="btn btn-small" :class="'btn-' + getSelectedPermissionClass(permission)+ ' px-4'" @click="selectPermissionTrigger(permission)"> <i class="icon-key"></i> {{permission.displayName}}   </button>
			</div>
		 </div>
		 <div class="row">
            <div class="col text-left">
                <button class="btn btn-link px-0" type="button" @click="goPrev">이전 페이지로 돌아가기</button>	
            </div>
		    <div class="col text-right">
                <button class="btn btn-primary px-4" type="button" @click="requestPermission">
                    <i class="icon-paper-plane"></i>
                    권한요청
                </button>
		    </div>
		</div>
        </div>
</template>

<script>
    import '../../../lib/polyfill'
    import request from '../../../lib/request'

    const PERMISSIONS = [
        {
            displayName: '공고문',
            value: 0b010,
						type: 2
        },
        {
            displayName: '홍보물',
            value: 0b100,
						type: 3
        },
        {
            displayName: '행사일정',
            value: 0b100,
						type: 5
        }/*,
        {
            displayName: '입',
            value: 0b001
        }*/
    ],
        LOGIN_PATH_URL = '/pages/login.html'

    export default {
        name: 'login',
        data () {
            return {
                sabun: '',
                userId: '',
                userPass: '',
                selectedPermission: 0b000,
                permissions: PERMISSIONS,
				roles: [],
				organs: [],
				checkedMember :false
            }
        },
        methods: {
            requestPermission () {
							this.sabun = this.userId
							this.selectedPermissionArr

                if (this.sabun && this.sabun) {
                    if (this.userId && this.userId !== '') {
                       // if (this.userPass && this.userPass !== '') {
                       		this.$log.debug('request permission 사번 :', this.sabun, ', ID :', this.userId, ', PW :', this.userPass, ', 권한 :', this.selectedPermission)
                                request.user.requestPermission({
                                    sabun: this.sabun,
                                    userId: this.userId,
                                    userPass: this.userPass,
                                    roles: this.roles,
									organs: this.organs,
									checkedMember : 'N'
                                })
                                    .then(result => {
                                        let err
                                        if (result.data.result === 200) {
                                            if (confirm('이 름 : '+result.data.memberInfo.userName+'\n소 속 : '+result.data.memberInfo.organName+'\n업 무 : '+result.data.memberInfo.duty+'\n\n권한 요청을 하시겠습니까?')) {
												this.$log.debug('request permission 사번 :', this.sabun, ', ID :', this.userId, ', PW :', this.userPass, ', 권한 :', this.selectedPermission)
				                                request.user.requestPermission({
				                                    sabun: this.sabun,
				                                    userId: this.userId,
				                                    userPass: this.userPass,
				                                    roles: this.roles,
													organs: this.organs,
													checkedMember : 'Y'
				                                })
				                                    .then(result => {
				                                        let err
				
				                                        if (result.data.result === 200) {
				                                            this.$log.debug('권한 요청 성공 ', result.data)
				                                            confirm('권한을 요청했습니다.')
				
				                                            // login 페이지로 이동
				                                            location.href = LOGIN_PATH_URL
				                                        } else {
				                                            err = new Error(result.data.resultMsg)
				                                            err.resultData = result.data
				                                            throw err
				                                        }
				                                    })
				                                    .catch(err => {
				                                        this.$log.error('권한 요청 실패 ', err)
				                                        alert('권한 요청에 실패했습니다.\n' + err.message)
				                                    })
				                                // 권한 요청 API 호출
				                            }
                                        } else {
                                            err = new Error(result.data.resultMsg)
                                            err.resultData = result.data
                                            throw err
                                        }
                                    })
                                    .catch(err => {
                                        this.$log.error('사용자 확인 실패 ', err)
                                        //alert('권한 요청에 실패했습니다.\n' + err.message)
                                        alert(err.message)
                                    })
                                // 권한 요청 API 호출
                            
                       // } else {
                       //     alert('PASSWORD를 입력하세요')
                       // }
                    } else {
                        alert('ID를 입력하세요')
                    }
                } else {
                    alert('사번을 입력하세요')
                }
            },
            getSelectedPermissionClass (permission) {
                return this.isSelectedPermission(permission) ? 'warning' : 'light'
            },
            isSelectedPermission (permission) {
                let result = false

                if (permission) {
                    result = this.selectedPermission & permission.value ? true : false
                }

                return result
            },
            selectPermissionTrigger (permission) {
                let index

                this.$log.debug('select permission => permission :', permission)

                if (permission) {
                    this.selectedPermission ^= permission.value
                }
            },
            goPrev()
            {
              this.$router.go(-1); // 이전 페이지로
            }
        },
        computed: {
            selectedPermissionArr () {
                //return Array.from(this.selectedPermission.toString(2).padStart(PERMISSIONS.length, '0'))
                // return Array.from(this.selectedPermission.toString(2).padStart(3, '0'))

								this.roles = []
								return this.permissions.map(role => {
									if(this.selectedPermission & role.value)
										this.roles.push(role.type)
								})
      	}
        }
    }
</script>
